import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { MetaPixel } from './components/MetaPixel';
import { LandingPage } from './pages/LandingPage';
import { ThankYouPage } from './pages/ThankYouPage';
export function App() {
  return <BrowserRouter data-id="element-0">
      <MetaPixel data-id="element-1" />
      <Routes data-id="element-2">
        <Route path="/gracias" element={<ThankYouPage data-id="element-4" />} data-id="element-3" />
        <Route path="/" element={<LandingPage data-id="element-6" />} data-id="element-5" />
        {/* Fallback: cualquier otra ruta muestra la landing */}
        <Route path="*" element={<LandingPage data-id="element-8" />} data-id="element-7" />
      </Routes>
    </BrowserRouter>;
}